// Scope of AAD app. Use the below configuration to use all the permissions provided in the AAD app through Azure portal.
// Refer https://aka.ms/PowerBIPermissions for complete list of Power BI scopes
export const powerConfig = {
  auth: {
    clientId: import.meta.env.VITE_AZURE_AD_CLIENT_ID,
    authority: import.meta.env.VITE_AZURE_AD_AUTHORITY,
  },
  api: {
    scope: import.meta.env.VITE_REPORT_API_SCOPE,
    scope2: import.meta.env.VITE_DASHBOARD_API_SCOPE,
  },
};
